import { flexRender, Header } from "@tanstack/react-table";
import { cn } from "@/lib/utils";

interface TableHeaderProps<TData> {
  header: Header<TData, unknown>;
}

export function TableHeader<TData>({ header }: TableHeaderProps<TData>) {
  const meta = header.column.columnDef.meta as { className?: string; stickyLeft?: number } | undefined;

  if (header.isPlaceholder) return null;

  return (
    <th
      className={cn(
        "px-4 py-3 text-left font-medium text-muted-foreground",
        // Pinned column: opaque background so scrolled columns slide underneath it
        meta?.stickyLeft !== undefined && "sticky z-30 bg-muted",
        meta?.className
      )}
      style={meta?.stickyLeft !== undefined ? { left: meta.stickyLeft } : undefined}
    >
      {flexRender(header.column.columnDef.header, header.getContext())}
    </th>
  );
}
